<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">BOM编号</label>
            <em class="weui-form-preview__value">{{form.main.bo_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成品编号</label>
            <span class="weui-form-preview__value">{{form.main.bo_mothercode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">成品名称</label>
            <span class="weui-form-preview__value">{{form.main.bo_mothername}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_orispeccode">
            <label class="weui-form-preview__label">成品型号</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{form.main.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">版本号</label>
            <span class="weui-form-preview__value">{{form.main.bo_version}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{form.main.bo_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">整体损耗%</label>
            <span class="weui-form-preview__value">{{form.main.bo_lossrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">BOM类型</label>
            <span class="weui-form-preview__value">{{form.main.bo_type ? '研发BOM' : '量产BOM'}}</span>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="nav">
          <div class="title">工序：</div>
          <div :class="[num == -1 ? 'active' : 'notActive']" @click="select(-1)">全部</div>
          <div
            :class="[num == index ? 'active' : 'notActive']"
            v-for="(item, index) in form.processInfoDTOList"
            :key="item.main.bp_detno"
            @click="select(index)"
            >{{item.main.bp_name}}</div>
        </div>
        <div class="detail" v-if="SFList.length">
          <div class="form-preview weui-form-preview" v-for="(item, index) in SFList" :key="index">
            <div class="weui-form-preview__bd form-detail-preview">
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">半成品编号</label>
                <span class="weui-form-preview__value">{{item.bomDTO.bo_mothercode}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">半成品名称</label>
                <span class="weui-form-preview__value">{{item.bomDTO.bo_mothername}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">半成品型号</label>
                <span class="weui-form-preview__value">{{item.bomDTO.pr_orispeccode}}</span>
              </div>
            </div>
            <div
              class="weui-form-preview__bd form-detail-preview"
              v-for="(item, index) in item.bomDetailList"
              :key="index"
            >
              <div class="form-detail-preview_num">{{item.bd_detno}}</div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">工序</label>
                <span class="weui-form-preview__value">{{item.bd_process}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">物料编号</label>
                <span class="weui-form-preview__value">{{item.bd_soncode}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">物料名称</label>
                <span class="weui-form-preview__value">{{item.pr_detail}}</span>
              </div>
              <div class="weui-form-preview__item" v-if="item.pr_orispeccode">
                <label class="weui-form-preview__label">型号</label>
                <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">单位</label>
                <span class="weui-form-preview__value">{{item.pr_unit}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">标准用量</label>
                <span class="weui-form-preview__value">{{item.bd_baseqty}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">位号</label>
                <span class="weui-form-preview__value">{{item.bd_location}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">备注</label>
                <span class="weui-form-preview__value">{{item.bd_remark}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">明细损耗%</label>
                <span class="weui-form-preview__value">{{item.bd_lossrate || 0}}</span>
              </div>
              <div class="weui-form-preview__item" v-if="item.pr_spec">
                <label class="weui-form-preview__label">规格</label>
                <span class="weui-form-preview__value">{{item.pr_spec}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">标准损耗%</label>
                <span class="weui-form-preview__value">{{item.pr_lossrate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="detail" v-else>
          <div class="form-preview weui-form-preview">
            <div
              class="weui-form-preview__bd form-detail-preview"
              v-for="(item, index) in OSList"
              :key="index"
            >
              <div class="form-detail-preview_num">{{item.bd_detno}}</div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">工序</label>
                <span class="weui-form-preview__value">{{item.bd_process}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">物料编号</label>
                <span class="weui-form-preview__value">{{item.bd_soncode}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">物料名称</label>
                <span class="weui-form-preview__value">{{item.pr_detail}}</span>
              </div>
              <div class="weui-form-preview__item" v-if="item.pr_orispeccode">
                <label class="weui-form-preview__label">型号</label>
                <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">单位</label>
                <span class="weui-form-preview__value">{{item.pr_unit}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">标准用量</label>
                <span class="weui-form-preview__value">{{item.bd_baseqty}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">位号</label>
                <span class="weui-form-preview__value">{{item.bd_location}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">备注</label>
                <span class="weui-form-preview__value">{{item.bd_remark}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">明细损耗%</label>
                <span class="weui-form-preview__value">{{item.bd_lossrate || 0}}</span>
              </div>
              <div class="weui-form-preview__item" v-if="item.pr_spec">
                <label class="weui-form-preview__label">规格</label>
                <span class="weui-form-preview__value">{{item.pr_spec}}</span>
              </div>
              <div class="weui-form-preview__item">
                <label class="weui-form-preview__label">标准损耗%</label>
                <span class="weui-form-preview__value">{{item.pr_lossrate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/make/bom",
      num: -1,
      OSList: [], // 原材料
      SFList: [], // 半成品和原材料
      form: {
        main: {},
        items: [],
        processInfoDTOList: []
      }
    };
  },
  mounted() {
    if (this.initData) {
      this.select(-1)
    }
  },
  watch: {
    initData(newVal) {
      if (newVal) {
        this.select(-1)
      }
    }
  },
  methods: {
    f_afterload() {
      this.select(-1)
    },
    select(num) {
      this.SFList = []
      this.OSList = []
      this.num = num
      if(num >= 0 && this.form.processInfoDTOList.length) {
        if(this.form.processInfoDTOList[num].processProductInfoDTOList) {
          this.SFList = this.form.processInfoDTOList[num].processProductInfoDTOList
        }
        else {
          this.OSList = this.form.processInfoDTOList[num].items
        }
      }
      else if(num < 0 && this.form.processInfoDTOList.length) {
        for(let i of this.form.processInfoDTOList) {
          this.OSList = this.OSList.concat(i.items)
        }
        if(!this.OSList.length) {
          this.OSList = this.form.items
        }
      }
      else {
        this.OSList = this.form.items
      }
    }
  },
};
</script>

<style scoped>
.content {
  display: flex;
}
.nav {
  flex: 1;
  margin-right: 20px;
}
.nav div {
  width: 100%;
  height: 35px;
  /* background: #fff; */
  background: var(--weui-BG-2);
  padding-left: 10px;
  font-size: 14px;
  line-height: 35px;
  font-weight: bold;
}
.nav .title {
  /* color: black; */
  color: var(--weui-FG-0);
}
.nav .notActive {
  color: #888;
}
.nav .active {
  color: aqua;
}
.detail {
  flex: 6;
}
</style>